<template>
  <div class="static-content">
    <component
      :is="compMap[item.type]"
      v-for="(item, index) in list"
      :key="index"
      :data="item.data"
    ></component>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import StaticImage from '@/modules/common/StaticImage.vue';
import StaticGif from '@/modules/common/StaticGif.vue';
@Component({
  components: {
    StaticImage,
    StaticGif,
  },
})
export default class StaticContent extends Vue {
  compMap = {
    image: StaticImage,
    gif: StaticGif,
  };
  @Prop({ type: Array, default: () => [] }) list!: any[];
}
</script>

<style lang="scss" scoped>
.static-content {
  .agreement-padding {
    width: 100%;
    height: 154px;
    background: #3b3561;
  }
}
</style>
